import { createFileRoute } from "@tanstack/react-router";
import { AgingPage } from "@/features/invoiceaging/AgingPage";

export const Route = createFileRoute("/_app/invoices/aging")({
  component: AgingPage,
});
